import React from "react";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { RadioButton } from "unified-ui-components-library";


let questionsWithTextBox = ["Q3","Q4","Q5","Q7"]

export const generateInputs =(question,handleRadioChange,handleChange,handlePopUp,handleSubQuestions)=>{
    switch(question.type){
        case 'radio':
            return(
                <div key={question.questionId}>
                    
                    <p>{question.listStyleQuestion?question.listStyleQuestion:question.questionId}{question.questionText} {question.questionId==="Q5"?<span onClick={handlePopUp} style={{position:'absolute'}}><InfoOutlinedIcon color="var(--color-icon-default)"/></span>:null} </p> 
                    <div className="radio-grp">
                        <RadioButton
                            label="Yes"
                            name={question.questionId}
                            value="Yes"
                            id={`${question.questionId}-Yes`}
                            checked={question.answer === 'Yes' ? true : false}
                            onChange={(e) => handleRadioChange({ target : { name: question.questionId, value: e }})}
                        />
                    </div>
                    <div className="radio-grp" >
                        <RadioButton
                            label="No"
                            name={question.questionId}
                            id={`${question.questionId}-No`}
                            value="No"
                            checked={question.answer === 'No' ? true : false}
                            onChange={(e) => handleRadioChange({ target : { name: question.questionId, value: e }})}
                        />
                    </div>
                    {question.err?<div className="err-msg-cntnr">
                        <p className="err-msg" >{question.errMsg}</p>
                    </div>:null}
                   <div>
                   {question.answer==='Yes'&&questionsWithTextBox.includes(question.questionId)?<input type="text" className="text-input" placeholder='Please provide details' onChange={handleChange} value={question.additionalInformation} name={question.questionId} />:null}
                   </div>
                  {/* {question.questionId=='Q3'&&question.answer=="Yes"? <div style={{marginLeft:'1rem'}}>
                       {question.subQuestions.length&&question.subQuestions.map(qst=>(
                           generateInputs(qst,null,null,null,handleSubQuestions)
                       ))}
                       </div>:null} */}
                </div>
            )
        case 'label':
            return <p key={question.questionId}>{question.questionId}{question.questionText}</p>
        case 'multipleTextFields':
            return(
                <div>
                <p key={question.questionId}>{question.questionId}{question.questionText}</p>
               {question.fields.map(field=>(
                  <div>
                  <input 
                    type="text" 
                    className="text-input" 
                    placeholder={field.placeholder}
                    onChange={handleSubQuestions} 
                    value={field.value} 
                    name={question.questionId}
                    id = {field.id}
                    key ={field.id} 
                />
                  </div>
                 
               ))}
            </div>
            )
        case 'radioWithCustomOptions':
            return (
                <div key={question.questionId}>
                    <p>{question.questionId}{question.questionText}</p>
                    {question.options.map(opt => (
                        <div className="radio-grp" key={opt}>
                            <RadioButton
                                name={question.questionId}
                                value={opt}
                                label={opt}
                                checked={question.answer === opt ? true : false}
                                onChange={(e) => handleSubQuestions({ target: { name: question.questionId, value: e, type: 'radio', id: `${question.questionId}-${opt}` } })}
                            />
                        </div>
                    ))}
                </div>
            )
        default:
            return null
    }
}